const auth = {
  // 身份证照片获取身份证信息
  idcard: `/chargeApi/auth/idcard`,
  // 提交实名信息
  personal: `/chargeApi/auth/personal`,
  // 上传图片
  imageUpload: `/uploadsApi/cdnapp/universalUpload.php`,
  // 获取提现配置
  info: `/payApi/v1/Extract/info`,
  // 获取提现配置v2
  infoV2: `/payApi/v2/Extract/info`,
  // 金币提现签约
  userSign: `/payApi/v1/Extract/userSign`,
  // 获取用户提现列表
  Apply: `/payApi/v1/Extract/Apply`,
  // 获取用户提现列表V2
  ApplyV2: `/payApi/v2/Extract/Apply`,
  // 获取用户提现列表V3
  ApplyV3: `/payApi/v3/Extract/Apply`,
  // 提现申请列表
  ExtractrList: `/payApi/v1/Extract/ExtractrList`,
  // 实名认证---带滑块验证
  Identify: `/userApi/v2/Identify/index`,
  // 获取实名认证页面文案
  findAntiText: `/userApi/v1/Identify/findAntiText`,
  // 实名认证---防沉迷
  IdentifyV1: `/userApi/v1/Identify/index`,
  // --------------------认证系统--------------
  // 获取分页认证列表
  authList: `/authApi/user/v1/auth/list`,
  // 获取认证说明描述信息
  authDesc: `/authApi/user/v1/auth/desc`,
  // 用户手机操作信息
  phoneOptionInfo: `/authApi/user/v1/phoneOptionInfo`,
  // 根据types获取说明信息
  batchGet: `/authApi/box/v1/explain/batchGet`,
  // 获取充值协议文本
  rechargeAgreementUrl: `/authApi/user/v1/agreement/rechargeAgreementUrl`,
  // 未激活SVIP权益
  queryNonSvipUserPosition: `/authApi/svip/v1/queryNonSvipUserPosition`,
  // --------------------用户申诉--------------
  // 用户申诉处理记录分页
  record: `/authApi/user/v1/appeal/record`,
  // 用户手机申诉数据上报
  appeal: `/authApi/user/v1/phone/appeal`,
  // 用户账户密码申诉数据上报
  accountAppeal: `/authApi/user/v1/account/appeal`,
  // 获取用户申诉详情数据(不需要鉴权，需要签名)
  detail: `/authApi/user/v1/appeal/detail`,
  // 通过申诉修改用户密码
  modify: `/authApi/user/v1/appeal/modify`,
  // 获取oss直传参数
  getOssSign: `/authApi/user/oss/config`,
  // --------------------消息客服列表--------------
  // 消息客服
  serviceMessage: `/authApi/user/v1/customer/service/message`,
  // --------------------支付密码--------------
  // 获取支付密码设置基础信息
  paySetting: `/authApi/user/v1/pay/setting`,
  // 发送短信验证码
  sendSms: `/authApi/user/v1/send/sms`,
  // 验证验证码
  checkCode: `/authApi/user/v1/check/phone/code`,
  // 设置支付密码
  settingPayPassword: `/authApi/user/v1/setting/pay/password`,
  // 验证支付密码
  verifyPayPassword: `/authApi/user/v1/verify/pay/password`,
  // 修改支付密码
  changePayPassword: `/authApi/user/v1/change/pay/password`,
  // 关闭支付密码
  closePayPassword: `/authApi/user/v1/close/pay/password`,
  // 设置提醒次数
  settingRemindNum: `/authApi/user/v1/setting/remind/num`,
  // 通过手机号修改支付密码
  passwordByPhone: `/authApi/user/v1/change/pay/passwordByPhone`,
  // --------------------获取充值元宝协议--------------
  fixedUrlByCode: `/authApi/user/v1/agreement/fixedUrlByCode`,
  // --------------------人脸签约--------------
  // 查询用户人脸签约状态
  getUserSignFace: `/payApi/v3/extract/getUserSignFace`,
  // 用户人脸签约
  userSignFace: `/payApi/v3/extract/userSignFace`
};

export default auth;
